import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import _ from "lodash";
import moment from "moment-timezone";
import ls from "local-storage";

import CreateFeedbackModal from "components/modals/create-feedback-modal";
import { DormitoryTab as BookingTab, NotFoundWrapper } from "components/pages/dormitories-page";
import StatusLabel, { BookingStatuses } from "components/ui-kit/status-label";
import { Breadcrumb, Button, Container, Frame, RowWrapper } from "components/ui-kit/styled-templates";

import BookingsApi from "api/bookings-api";
import EventsApi from "api/events-api";
import UniversityApi from "api/university-api";

import ModalsService from "services/modals-service";

import useBodyBackground from "hooks/useBodyBackground";
import { useStorageListener } from "hooks/useStorage";

import { EModals, ERequestStatus } from "types/enums";
import Sidebar from "arui-feather/sidebar";
import RoomChatPanel from "../chat/panels/RoomChatPanel";

import ch_im from "../../assets/images/chat_im.svg";

const BookingsListPage = () => {
    const { t, i18n } = useTranslation();
    let isRu = i18n.language === "ru";

    // @ts-ignore
    let isAdminMode = (ls("admin_mode") == "yes");

    useBodyBackground(`white`);
    const bookings = useStorageListener(`bookings`, []);
    const eventsBookings = useStorageListener(`events-requests`, {});
    const universities = useStorageListener(`universities`, {});
    const dormitories = useStorageListener(`dormitories`, {});
    const rooms = useStorageListener(`rooms`, []);
    const userId = useStorageListener(`user.id`, ``);
    const events = useStorageListener(`events`, {});

    let allBookings = { ...bookings, ...eventsBookings };

    console.log("--_>>eventsBookings = ", eventsBookings);

    const [selectedChatId, setSelectedChatId] = useState(undefined);
    const selectedChatBooking = (selectedChatId == undefined) ? undefined : allBookings[selectedChatId];
    console.log("render: allBookings = ", allBookings);
    console.log("render: selectedChatBooking = ", selectedChatBooking);
    let selectedChatDormitoryId = selectedChatBooking?.dormitoryId;
    console.log("render: selectedChatDormitoryId = ", selectedChatDormitoryId);
    let selectedChatDormitory = (selectedChatDormitoryId == undefined) ? undefined : dormitories[selectedChatDormitoryId];
    let selectedChatUni = (selectedChatDormitory == undefined) ? undefined : universities[selectedChatDormitory?.universityId];
    console.log("selectedChatDormitory = ", selectedChatDormitory);
    let selectedChatDormitoryCommittee = selectedChatDormitory?.details?.rules?.committee;
    console.log("selectedChatDormitoryCommittee = ", selectedChatDormitoryCommittee);
    console.log("selectedChatUni = ", selectedChatUni);

    const myEventsBookings = _(eventsBookings)
        .values()
        .filter({ userId })
        .map((i) => ({ ...i, event: events?.[i?.eventId] }))
        .filter((i) => !_.isEmpty(i.event))
        .keyBy("id")
        .value();

    const handlers = {
        editBooking: (id) => () => {
        },
        deleteBooking: (id: string) => async () => {
            ModalsService.showModality({
                title: `Отмена бронирования`,
                description: `Вы уверены, что хотите отменить это бронирование?`,
                cancelButton: {
                    children: `Нет, не отменять`,
                    background: `gray`
                },
                confirmButton: {
                    children: `Да, отменить бронирование`,
                    background: `red`,
                    onClick: async () => await BookingsApi.updateBooking({ id: id, status: ERequestStatus.Canceled })
                }
            });
        },
        deleteEventBooking: (id: string) => async () => {
            ModalsService.showModality({
                title: `Отмена бронирования`,
                description: `Вы уверены, что хотите отменить это бронирование?`,
                cancelButton: {
                    children: `Нет, не отменять`,
                    background: `gray`
                },
                confirmButton: {
                    children: `Да, отменить бронирование`,
                    background: `red`,
                    onClick: async () => {
                        await BookingsApi.updateEventBooking({
                            id: id,
                            status: ERequestStatus.Canceled
                        });
                        window.location.reload();
                    }
                }
            });
        },
        openCreateDormFeedbackModal: (dormitoryId: string) => () => {
            ModalsService.showModal(EModals.CreateFeedback, { dormitoryId });
        },
        openCreateEventFeedbackModal: (eventId: string) => () => {
            ModalsService.showModal(EModals.CreateFeedback, { eventId });
        }
    };

    useEffect(() => {
        BookingsApi.getMyBookings();
    }, []);

    useEffect(() => {
        EventsApi.getMyBookings();
    }, []);

    useEffect(() => {
        EventsApi.getEvents();
    }, []);

    useEffect(() => {
        UniversityApi.getAllUniversitiesData();
    }, []);

    return (
        <>
            <CreateFeedbackModal />
            <Container>
                <Breadcrumb.Wrapper>
                    <Breadcrumb.Item to="/">{t("kjua60xi7ql")}</Breadcrumb.Item>
                </Breadcrumb.Wrapper>
                <RowWrapper
                    extra={`h1 { margin: 0; }; @media (max-width: 991px) { flex-direction: column; gap: 15px; align-items: flex-start; h1 { font-size: 44px; }; };`}
                >
                    <h1>{t("yprbij24c8p")}</h1>
                    <Link to="/search">
                        <Button variant="outlined">{t("2d8zwiamhwq")}</Button>
                    </Link>
                </RowWrapper>
                <RowWrapper extra={`margin-top: 56px; flex-wrap: wrap; gap: 40px;`}>
                    {_.values(bookings)?.map?.((item, index) => {
                        return (
                            <BookingTab.Wrapper key={index}>
                                <RowWrapper
                                    extra="@media (max-width: 991px) { flex-direction: column; gap: 8px; align-items: flex-start; };">
                                    <BookingTab.Name empty={false} extra="margin-bottom: 4px;">
                                        {_.get(dormitories, `${item?.dormitoryId}.details.main-info.name`)}
                                    </BookingTab.Name>
                                    <StatusLabel status={item?.status}>{BookingStatuses?.[item?.status]}</StatusLabel>
                                </RowWrapper>
                                <Frame extra={({ theme }) => `color: ${theme.blue};`}>
                                    {_.get(dormitories, `${item?.dormitoryId}.details.main-info.city`)}
                                </Frame>
                                <BookingTab.DetailsWrapper>
                                    <div>
                                        <p>{t("juio465ch1q")}</p>
                                        <strong>
                                            {moment(item?.dates?.from, `YYYY-MM-DD`).format(`DD.MM.YYYY`)} -{" "}
                                            {moment(item?.dates?.to, `YYYY-MM-DD`).format(`DD.MM.YYYY`)}
                                        </strong>
                                    </div>
                                    <div>
                                        <p>{t("1neocsh4qy9")}</p>
                                        <strong>{item?.quantity}</strong>
                                    </div>
                                    <div>
                                        <p>{t("5dtofztoaqp")}</p>
                                        <strong>
                                            {t("1eerii6i438")} {_.get(rooms, `${item.roomId}.details.price`)} ₽
                                        </strong>
                                    </div>
                                </BookingTab.DetailsWrapper>
                                {item.status == ERequestStatus.Canceled ? null : (
                                    <>
                                        {/*{item.status === ERequestStatus.New && (*/}
                                        <Link to={`/edit-booking/${item?.id}`}>
                                            <BookingTab.Link color="blue">{t("aotslafkgqg")}</BookingTab.Link>
                                        </Link>
                                        {/*)}*/}

                                        {item.status === ERequestStatus.DoneVisited && (
                                            <BookingTab.Link color="blue"
                                                             onClick={handlers.openCreateDormFeedbackModal(item.dormitoryId)}>
                                                {t("aotslafkgqq")}
                                            </BookingTab.Link>
                                        )}

                                        {/*{item.status === ERequestStatus.New && (*/}
                                        <BookingTab.Link color="red" onClick={handlers.deleteBooking(item?.id)}>
                                            {t("4b1s6kr881e")}
                                        </BookingTab.Link>

                                        <BookingTab.Link style={{
                                            textAlign: "right",
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            width: "100%"
                                        }} color="blue" onClick={() => {
                                            setSelectedChatId(`${item?.id}`);
                                        }}>
                                            <img src={ch_im} style={{ height: "34px" }} />
                                            Чат
                                        </BookingTab.Link>

                                        {/*)}*/}
                                    </>
                                )}
                            </BookingTab.Wrapper>
                        );
                    })}
                </RowWrapper>
                <RowWrapper
                    extra={`h1 { margin: 0; margin: 25px; margin-left: 0px; }; @media (max-width: 991px) { flex-direction: column; gap: 15px; align-items: flex-start; h1 { font-size: 44px; }; };`}
                >
                    <h1
                    >{t("y7i7107o1m9")}</h1>
                    <Link to="/events-search">
                        <Button variant="outlined">{t("913c4senn6b")}</Button>
                    </Link>
                </RowWrapper>
                <RowWrapper extra={`margin-top: 56px; flex-wrap: wrap; gap: 40px; margin-bottom: 25px;`}>
                    {_.values(myEventsBookings)?.map?.((item, index) => {
                        return (
                            <BookingTab.Wrapper key={index}>
                                <RowWrapper
                                    extra="@media (max-width: 991px) { flex-direction: column; gap: 8px; align-items: flex-start; };">
                                    <BookingTab.Name empty={false} extra="margin-bottom: 4px;">
                                        {_.get(item, `event.details.name`)}
                                    </BookingTab.Name>
                                    <StatusLabel status={item?.status}>{BookingStatuses?.[item?.status]}</StatusLabel>
                                </RowWrapper>
                                <Frame extra={({ theme }) => `color: ${theme.blue};`}>
                                    {_.get(dormitories, `${item?.dormitoryId}.details.main-info.city`)}
                                </Frame>
                                <BookingTab.DetailsWrapper>
                                    <div>
                                        <p>{t("2p28ej2ynlk")}</p>
                                        <strong>
                                            {moment(item?.event?.details?.dates?.from).format(`DD.MM.YYYY`)} -{" "}
                                            {moment(item?.event?.details?.dates?.to).format(`DD.MM.YYYY`)}
                                        </strong>
                                    </div>
                                    {(item?.event?.details?.from_time == undefined || item?.event?.details?.from_time == '') ? null :
                                        <div>
                                            <p>{isRu ? 'Время начала' : 'Time of the start'}</p>
                                            <strong>
                                                {item?.event?.details?.from_time}
                                            </strong>
                                        </div>
                                    }
                                    <div>
                                        <p>{t("w7a3p3f4s2h")}</p>
                                        <strong>{item?.details?.participants?.length}</strong>
                                    </div>
                                    <div>
                                        <p>{t("y93i21d8je")}</p>
                                        <strong>
                                            {t("0ph821s2rlkm")} {item?.event?.details?.price} ₽
                                        </strong>
                                    </div>
                                </BookingTab.DetailsWrapper>
                                {item.status == ERequestStatus.Canceled ? null : (
                                    <>
                                        {/*{item.status === ERequestStatus.New && (*/}
                                        <Link to={`/edit-event-booking/${item?.id}`}>
                                            <BookingTab.Link color="blue">{t("jbmh43gdqlg")}</BookingTab.Link>
                                        </Link>
                                        {/*)}*/}
                                        <BookingTab.Link color="blue"
                                                         onClick={handlers.openCreateEventFeedbackModal(item.eventId)}>
                                            {t("aotslafkgqq")}
                                        </BookingTab.Link>
                                        {/*{item.status === ERequestStatus.New && (*/}
                                        <BookingTab.Link color="red" onClick={handlers.deleteEventBooking(item?.id)}>
                                            {t("9o16ops1bye")}
                                        </BookingTab.Link>

                                        <BookingTab.Link style={{
                                            textAlign: "right",
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            width: "100%"
                                        }} color="blue" onClick={() => {
                                            setSelectedChatId(`${item?.id}`);
                                        }}>
                                            <img src={ch_im} style={{ height: "34px" }} />
                                            Чат
                                        </BookingTab.Link>

                                        {/*)}*/}
                                    </>
                                )}
                            </BookingTab.Wrapper>
                        );
                    })}
                </RowWrapper>
                {!_.keys(bookings).length && <NotFoundWrapper>{t("9ru5liteyi4")}</NotFoundWrapper>}
            </Container>

            <Sidebar visible={(selectedChatId != undefined)} onCloserClick={() => {
                setSelectedChatId(undefined);
            }}>

                {selectedChatId == undefined ? null :
                    <div>
                        {/*<h2 style={{*/}
                        {/*    display: "flex",*/}
                        {/*    flexDirection: "row",*/}
                        {/*    justifyContent: "space-between",*/}
                        {/*    alignItems: "center",*/}
                        {/*    marginBottom: 5*/}
                        {/*}}>*/}
                        {/*    <span>*/}
                        {/*        Чат*/}
                        {/*    </span>*/}
                        {/*    {isAdminMode == false ? null :*/}
                        {/*        <Button>*/}
                        {/*            Завершить*/}
                        {/*        </Button>*/}
                        {/*    }*/}
                        {/*</h2>*/}
                        {/*{selectedChatDormitoryCommittee == undefined ? null :*/}
                        {/*    <div style={{ fontSize: "12px" }}>*/}

                        {/*        <b>{selectedChatUni?.details?.name}</b>*/}
                        {/*        <br />*/}

                        {/*        {selectedChatDormitoryCommittee.name}*/}
                        {/*        <br />*/}

                        {/*        {`${selectedChatDormitoryCommittee.phone} , ${selectedChatDormitoryCommittee.email}`}*/}
                        {/*    </div>*/}
                        {/*}*/}
                        <div style={{
                            height: "calc(100vh - 50px)",
                            maxHeight: `calc(100vh - 50px)`,
                            overflowY: "hidden",
                            marginTop: "0px"
                        }}>
                            <RoomChatPanel
                                status={selectedChatBooking?.status}
                                roomId={selectedChatId} />
                        </div>
                    </div>
                }

            </Sidebar>

        </>
    );
};

export default BookingsListPage;
